import { render, staticRenderFns } from "./VInputFile.vue?vue&type=template&id=7d23e80a&scoped=true"
import script from "./VInputFile.vue?vue&type=script&lang=js"
export * from "./VInputFile.vue?vue&type=script&lang=js"
import style0 from "./VInputFile.vue?vue&type=style&index=0&id=7d23e80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23e80a",
  null
  
)

export default component.exports